import React from 'react';
import Image from 'next/image';
import Link from '../Link';
import { currency } from '../../utils/utils';
import { precioOriginalDesdeMayorista } from '../../utils/mayorista';
import ControlesCarrito from '../ControlesCarrito';
import styles from './styles.module.scss';

type ItemCarritoProps = {
    data: {
        producto: any
        cantidad: number
    }
    mayorista?: boolean
}

const ItemCarrito = (props: ItemCarritoProps) => {

  const { producto, cantidad } = props.data;
  const mayorista = props.mayorista || false;

  return (<>
    <div className={styles.item}>
      <div className={styles.principal}>
        <Link href={`/productos/${producto.attributes.slug}`} className={styles.thumbnailLink}>
          <Image
            className={styles.thumbnail}
            src={producto.attributes?.fotos?.data[0]?.attributes?.formats?.thumbnail?.url || "https://dummyimage.com/90x113/000000/ffffff"}
            alt={producto.attributes?.nombre || "Producto We Celebrate!"}
            width={90}
            height={113}
          />
        </Link>
        <div className={styles.info}>
          <Link href={`/productos/${producto.attributes.slug}${mayorista ? '?mayorista=true' : ''}`}>
            <h3 className={styles.nombre} title={producto.attributes?.nombre}>{producto.attributes?.nombre || '-'}</h3>
          </Link>
          {mayorista && <span className={styles.precioTachado}>$ {currency(precioOriginalDesdeMayorista(producto.attributes?.precioFinal))}</span>}
          <span className={styles.precio}>$ {currency(producto.attributes?.precioFinal)} c/u{mayorista ? ' mayorista' : ''}</span>
        </div>
      </div>
      <div className={styles.secundaria}>
        <ControlesCarrito producto={producto} leftAlign={true} mayorista={mayorista} />
        <p className={styles.subtotal}>$ {currency(producto.attributes?.precioFinal * Number(cantidad))}</p>
      </div>
    </div>
  </>);
};

export default ItemCarrito;
